/**
 * Real parent testimonials — keep this file as the single source of truth.
 * Add or edit entries here; both /v3 and / consume the same array.
 */
export const PARENT_TESTIMONIALS = [
    {
        name: "Taruna Vohra",
        grade: "Mother of Grade 9",
        school: "",
        city: "Mumbai",
        quote:
            "Hemangi is very knowledgeable, approachable, eager to help and patiently answered all our queries. We met her in a confused state and she helped iron out our doubts and gave us a sense of direction and clarity and empowered us to make decisions for our child.",
        // Short enough — no excerpt; full quote shown inline (see TRIM_LIMIT in Testimonial.jsx).
    },
    {
        name: "Rajvi Bhatia",
        grade: "Mother of Grade 8",
        school: "Chatrabhuj Narsee School",
        city: "Mumbai",
        excerpt:
            "I went in feeling overwhelmed by all the choices my daughter had. Ms. Hemangi patiently understood her strengths, interests and long-term aspirations before guiding us — and I walked away with complete clarity, confidence and peace of mind.",
        quote: `I had an incredibly enriching experience with Ms. Hemangi for subject selection counselling. Going into the session, I had several doubts and was feeling overwhelmed with the choices available that my daughter wanted to make. However, Ms. Hemangi patiently listened to my concerns, understood my daughter's strengths, interests, and long-term aspirations before guiding her through the entire process.

What truly stood out was her ability to simplify complex decisions and explain the advantages and future scope of each subject combination in a very practical and easy-to-understand manner. She never rushed the discussion and ensured that every question I had was answered with clarity and confidence. Her insights helped me and my daughter look beyond just marks and focus on choosing subjects that genuinely align with my daughter's personality, capabilities, and future career goals.

I walked away from the session with complete clarity, confidence, and peace of mind about my daughter's decision. It was one of the most valuable counselling sessions I have attended.

A heartfelt thank you to Ms. Hemangi for her patience, expertise, and genuine commitment to helping students make informed choices. I would highly recommend her counselling services to anyone looking for guidance in subject selection.`,
    },
];
